import { Box, ButtonProps, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { FC } from 'react';

import { usePopover } from '../../hooks/use-popover';
import { DotsVertical as DotsVerticalIcon } from '../../icons/dots-vertical';

export interface Action {
  key: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  tooltip?: string;
  hidden?: boolean;
}

interface ActionsMenuProps extends ButtonProps {
  actions: Action[];
  id?: string;
}

export const ActionsTableMenu: FC<ActionsMenuProps> = ({ actions, id }) => {
  const [anchorRef, open, handleOpen, handleClose] = usePopover();

  if (actions.every(action => action.hidden)) {
    return null;
  }

  return (
    <Box onClick={e => e.stopPropagation()}>
      <IconButton
        onClick={e => {
          e.preventDefault();
          handleOpen();
        }}
        ref={anchorRef}
        id={id}>
        <DotsVerticalIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
        disableScrollLock
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        {actions.map((action, i) => {
          if (action.hidden) {
            return null;
          }

          return action.tooltip ? (
            <Tooltip
              key={action.key}
              title={action.tooltip ?? ''}
              placement="left"
              disableHoverListener={!action?.disabled}>
              <span>
                <MenuItem
                  id={action.key}
                  onClick={() => {
                    action.onClick();
                    handleClose();
                  }}
                  disabled={action.disabled}>
                  {action.label}
                </MenuItem>
              </span>
            </Tooltip>
          ) : (
            <MenuItem
              id={action.key}
              key={i}
              onClick={() => {
                action.onClick();
                handleClose();
              }}
              disabled={action.disabled}>
              {action.label}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};
